<template>
  <div>
    <br />
    <div class="login-input-wrapper">
      <InputText
        id="email"
        type="email"
        placeholder="Email"
        v-model.trim="login.email"
        required="true"
      />
    </div>
    <br />
    <div class="login-input-wrapper">
      <InputText
        id="password"
        type="password"
        placeholder="Password"
        v-model.trim="login.password"
        required="true"
      />
    </div>
    <br />
    <Button label="Sign In" icon="pi pi-check" @click="Login" />
    &nbsp;
    <div class="anchorParent">
      <a class="anchorTag" @click="$emit('passwordForgotten')">Forgotten Password?</a>
    </div>
    <br />
    <br />
    <span class="error-text p-my-3">{{ this.error }}</span>
  </div>
</template>

<script>
import FiltersService from "@/service/FiltersSerice";
import RoleService from "@/service/RoleService";

import UserService from "@/service/UserService";
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      filtersService: new FiltersService(),
      roleService: new RoleService(),
      users: null,
      login: {},
      returnSecureToken: true,
      error: null,
    }
  },
  userService: null,
  created() {
    this.userService = new UserService();
  },
  mounted() {
    this.loading1 = false;
  },
  methods: {
    ...mapActions('auth', [
      'setMyProfile', // -> this.setMyProfile()
      'setMyToken', // -> this.setMyToken()
      'setMyRefreshToken', // -> this.setMyRefreshToken()
      'setNextRefreshTime', // -> this.setNextRefreshTime()
    ]),
    async Login() {
      this.error = null;
      this.login.returnSecureToken = true;
      if (this.login.email && this.login.password) {
        this.userService
          .login(this.login)
          .then((data) => (this.users = data))
          .then((data) => {
            this.$store.dispatch('setReLoginDialog', false)
            this.$store.dispatch('setErrorMessage', [])

            //this.$toast.add({severity:'success', summary: cred, detail: 'User Logged In', life: 5000});
            //
            // 

            this.setMyToken(data.idToken)
            this.setMyRefreshToken(data.refreshToken)
            this.setNextRefreshTime(new Date().getTime() + 300000) // refresh token in 5 mins... also see in axios.js response interceptor
            
            this.userService
              .getUser(data.idToken)
              .then((res) => {
                
                let a = {...res.data}
                console.log('userid', a)

                if (a.status === 'ACTIVE') {
                  this.setMyProfile(a)

                  this.users = data;
                  // this.$toast.add({
                  //   severity: "success",
                  //   summary: data,
                  //   detail: "Logged In",
                  //   life: 5000,
                  // });
                  this.roleService
                    .getUserPermissions(a.id)
                    .then((data) => {
                      this.$store.dispatch(`auth/setUserPermissions`, data)
                    })
                    .catch(error => {
                      this.$store.dispatch('addErrorMessage', {
                        severity: 'error',
                        content: 'Some data was not loaded from "getUserPermissions"'
                      })
                    })

                  if (
                    this.$store.getters.getLastPage 
                    && this.$store.getters.getLastPage !== '/'
                  ) {
                    if (this.$store.getters.getLastPage.substr(0, 6) === '/login') {
                      this.$router.push({ path: "/" });
                    } else {
                      this.$router.go(this.$store.getters.getLastPage);
                    }
                  } else {
                    this.$router.push({ path: "/" });
                  }

                } else {
                  this.$toast.add({
                    severity: "error",
                    summary: "USER INACTIVE",
                    detail: "The status has been set Inactive and you will not be able to login",
                    life: 5000,
                  })
                  this.logout()

                }

              })
              .catch((e) => {
                this.$toast.add({
                  severity: "warn",
                  summary: data,
                  detail: "Wrong Login Details",
                  life: 5000,
                });
                

                if (e.response && e.response.data === "List is empty.") {
                  this.error = "The user is not active in the MBP Group Synergy system. Please contact the administrator.";
                } else if (e.response && e.response.data === "user.notactive") {
                  this.error = "The status has been set Inactive and you will not be able to login.";
                } else {
                  this.error = "There was a problem while logging in, please contact your network administrator.";
                }
                localStorage.clear();

              });

            this.filtersService
              .getCurrUserFavFilters()
              .then(data => {
                

                this.$store.dispatch('commons/favoriteFilters', data)
              })
              .catch(error => {
                this.$store.dispatch('addErrorMessage', {
                  severity: 'error',
                  content: 'Some data was not loaded from "getCurrUserFavFilters"'
                })
              })
          })
          .catch((error) => {
            
            if (error && error.response && error.response.data.error.message === "EMAIL_NOT_FOUND") {
              this.error =
                "This email address is not recognised, please contact the admin team.";
            }
            if (error && error.response && error.response.data.error.message === "INVALID_PASSWORD") {
              this.error =
                "The password entered is incorrect, please try again";
            }
            // Firebase returns INVALID_LOGIN_CREDENTIALS when email-enumeration
            // protection is enabled (bad email OR bad password).
            if (error && error.response && error.response.data.error.message === "INVALID_LOGIN_CREDENTIALS") {
              this.error =
                "The email or password entered is incorrect, please try again";
            }
            // Never leave the message blank on an unrecognised auth error.
            if (!this.error) {
              this.error =
                "Unable to sign in. Please check your email and password and try again.";
            }
            this.feedback = error.message;
            localStorage.clear();
            
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: this.error,
              life: 5000,
            })
          });
      } else {
        // Guard against empty / browser-autofilled fields that never fired an
        // input event: surface a message instead of failing silently.
        this.error = "Please enter your email and password.";
        this.$toast.add({
          severity: "warn",
          summary: "Missing details",
          detail: this.error,
          life: 5000,
        });
      }
    },
    logout() {
      localStorage.removeItem('profile')
      localStorage.removeItem('user-token')
      localStorage.removeItem('user-refresh-token')
      setTimeout(() => {
        this.$store.dispatch('auth/setMyProfile', {})
        this.$store.dispatch('auth/setMyToken', '')
        this.$store.dispatch('auth/setMyRefreshToken', '')
        this.$router.push('/login?logout=true')
      }, 10)
    }
  }
}
</script>

<style scoped>

.anchorParent {
  display: inline-block;
}

.error-text {
  margin-bottom: 10px;
  display: flex;
  color: red;
}

</style>